module.exports = __webpack_public_path__ + "static/media/defaultLogo.f62657c6.svg";